import AiChatHistoryPage from 'src/@core/components/chat-history/AiChatHistoryPage'
import { AI_CATEGORIES } from 'src/@core/components/chat-history'

const AndroidLocalGeminiPage = () => (
  <AiChatHistoryPage category={AI_CATEGORIES.GEMINI} title='Gemini' mode='android-local' />
)

export default AndroidLocalGeminiPage
